<div class="lib-phone-input" [class.lib-phone-input--disabled]="disabled">

  <!-- ── Select de país ── -->
  <p-select
    class="lib-phone-input__country"
    [options]="countries"
    [(ngModel)]="selectedCountry"
    (onChange)="onCountryChange($event.value)"
    optionLabel="name"
    [filter]="true"
    filterBy="name,dialCode"
    [disabled]="disabled"
    appendTo="body"
    [overlayOptions]="overlayOptions"
  >
    <!-- Item selecionado: bandeira + DDI -->
    <ng-template #selectedItem let-country>
      @if (country) {
        <div class="lib-phone-input__selected">
          <span [class]="country.flagClass + ' lib-phone-input__flag'"></span>
          <span class="lib-phone-input__dial">{{ country.dialCode }}</span>
        </div>
      }
    </ng-template>

    <!-- Opção no dropdown: bandeira + nome + DDI -->
    <ng-template #item let-country>
      <div class="lib-phone-input__option">
        <span [class]="country.flagClass + ' lib-phone-input__flag'"></span>
        <span class="lib-phone-input__option-name">{{ country.name }}</span>
        <span class="lib-phone-input__option-dial">{{ country.dialCode }}</span>
      </div>
    </ng-template>
  </p-select>

  <!-- ── Campo de número ── -->
  <input
    pInputText
    type="tel"
    class="lib-phone-input__number"
    [value]="displayValue"
    [placeholder]="computedPlaceholder"
    [disabled]="disabled"
    autocomplete="tel"
    (input)="onPhoneInput($event)"
    (blur)="onPhoneBlur()"
  />

</div>
